import styled from 'styled-components';
import { css } from 'styled-components';

export const DividerWrapper = styled.div`
    [class*='Dividerstyle__Divider-sc'] {
        margin: 50px 0
    }
`;

export const videoContainer = css`
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
`;

export const videoiframe = css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
`;

export const iframeContainer = css`
    position: relative;
    overflow: hidden;
    left: -222px;
    width: 1200px;
    @media only screen and (max-width: 1215px) {
        left: -120px;
        width: 1000px;
        overflow: hidden;
    }
    @media only screen and (max-width: 1000px) {
        width: 100%;
        left: 0;
        overflow: hidden;
    }
`;

export const genericiframe = css`
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
`;

export const blockquoteStyle = css`
    margin: 0px 0px 1.3125rem;
    padding-left: 0.875rem;
    padding-right: 0.875rem;
    text-align: center;
    font-style: normal;
`;